// Shared Bridge Club feed constants — single source of truth for the Feed page
// (BridgeClubFeed.tsx) and the extracted Create Bin / Add Feed dialogs, so the
// category and feed-form options cannot drift between them.

export interface FeedCategory {
  value: string;
  label: string;
  emoji: string;
}

export interface FormTypeOption {
  value: string;
  label: string;
  icon: string;
}

export const FEED_CATEGORIES: FeedCategory[] = [
  { value: 'poultry', label: 'Poultry', emoji: '🐔' },
  { value: 'dog', label: 'Dog', emoji: '🐕' },
  { value: 'cat', label: 'Cat', emoji: '🐱' },
  { value: 'goat', label: 'Goat', emoji: '🐐' },
  { value: 'sheep', label: 'Sheep', emoji: '🐑' },
  { value: 'swine', label: 'Swine', emoji: '🐷' },
  { value: 'horse', label: 'Horse', emoji: '🐴' },
  { value: 'cattle', label: 'Cattle', emoji: '🐄' },
  { value: 'rabbit', label: 'Rabbit', emoji: '🐰' },
  { value: 'other', label: 'Other', emoji: '🐾' },
];

export const FORM_TYPES: FormTypeOption[] = [
  { value: 'pellet', label: 'Pellet', icon: '⚫' },
  { value: 'mash', label: 'Mash', icon: '🔘' },
  { value: 'whole', label: 'Whole Grain', icon: '🌾' },
];

// Cat and dog food don't have pellet/mash/whole variations
export const shouldShowFormType = (category: string): boolean => {
  return category !== 'cat' && category !== 'dog';
};
